import { render, staticRenderFns } from "./AddAgent.vue?vue&type=template&id=b8b9c550&"
import script from "./AddAgent.vue?vue&type=script&lang=js&"
export * from "./AddAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8b9c550')) {
      api.createRecord('b8b9c550', component.options)
    } else {
      api.reload('b8b9c550', component.options)
    }
    module.hot.accept("./AddAgent.vue?vue&type=template&id=b8b9c550&", function () {
      api.rerender('b8b9c550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/agents/AddAgent.vue"
export default component.exports